import { useEffect, useRef, useState } from "react";
import { Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import OtpInput from "react-otp-input";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { sendLoginOtp, LoginverifyOtp } from "../../../features/auth/Slice";
import { IDS } from "../../../utils/IDS";
import { GetAllUserTest, Getprofile } from "../../../redux/profile";
import Success_Modal from "../success-modal/Success_Modal";
import Start_Btn from "../../common/start-btn/Start_Btn";
import "./Login_Modal.css";

const OTP_LENGTH = 4;
const OTP_TIMER_SECONDS = 60;

const Login_Modal = ({ show, handleClose, handleLogin }) => {
  const dispatch = useDispatch();

  const { sendLoginOtpStatus, verifyLoginOtpStatus } = useSelector(
    (state) => state?.auth?.login ?? {}
  );

  const isSending = sendLoginOtpStatus === IDS.SLICESTATUS.Loading;
  const isVerifying = verifyLoginOtpStatus === IDS.SLICESTATUS.Loading;

  const [contact_no, setContact_no] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [phoneTouched, setPhoneTouched] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [showOtpStep, setShowOtpStep] = useState(false);
  const [isPhoneLocked, setIsPhoneLocked] = useState(false);
  const [timer, setTimer] = useState(0);
  const [successShow, setSuccessShow] = useState(false);
  const [loginSuccessShow, setLoginSuccessShow] = useState(false);
  const [loginSuccessData, setLoginSuccessData] = useState(null);

  const timerRef = useRef(null);
  const successTimeoutRef = useRef(null);
  const loginSuccessTimeoutRef = useRef(null);

  const clearTimers = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    if (successTimeoutRef.current) {
      clearTimeout(successTimeoutRef.current);
      successTimeoutRef.current = null;
    }
    if (loginSuccessTimeoutRef.current) {
      clearTimeout(loginSuccessTimeoutRef.current);
      loginSuccessTimeoutRef.current = null;
    }
  };

  useEffect(() => {
    if (show) {
      clearTimers();
      setContact_no("");
      setPhoneError("");
      setPhoneTouched(false);
      setOtp("");
      setOtpError("");
      setShowOtpStep(false);
      setIsPhoneLocked(false);
      setTimer(0);
      setSuccessShow(false);
      setLoginSuccessShow(false);
      setLoginSuccessData(null);
    }
  }, [show]);
  const startTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setTimer(OTP_TIMER_SECONDS);
    timerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Cleanup on unmount only
  useEffect(() => () => clearTimers(), []);

  const validatePhone = (value) => {
    if (!value) return "Contact No is required";
    if (!/^\d{10}$/.test(value)) return "Please enter a valid 10-digit Phone Number";
    return "";
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
    setContact_no(value);
    if (phoneTouched) setPhoneError(validatePhone(value));
    else if (value.length === 10) setPhoneError("");
  };

  const handlePhoneBlur = () => {
    setPhoneTouched(true);
    setPhoneError(validatePhone(contact_no));
  };

  const handleChangeNumber = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setIsPhoneLocked(false);
    setShowOtpStep(false);
    setOtp("");
    setOtpError("");
    setTimer(0);
  };

  const handleSendOtp = async (isResend = false) => {
    const err = validatePhone(contact_no);
    if (err) {
      setPhoneTouched(true);
      setPhoneError(err);
      return;
    }
    setPhoneError("");
    try {
      const response = await dispatch(sendLoginOtp({ contact_no }));
      if (response?.payload?.success) {
        setOtp("");
        setOtpError("");
        setShowOtpStep(true);
        setIsPhoneLocked(true);
        startTimer();
        setSuccessShow(true);
        if (successTimeoutRef.current) clearTimeout(successTimeoutRef.current);
        successTimeoutRef.current = setTimeout(() => setSuccessShow(false), 1200);
      } else {
        const message =
          response?.payload?.message ||
          response?.error?.message ||
          (isResend ? "Failed to resend OTP. Please try again." : "Failed to send OTP. Please try again.");
        setPhoneError(message);
      }
    } catch (error) {
      console.error("Failed to send login OTP:", error);
      setPhoneError("Failed to send OTP. Please try again.");
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      setOtpError("Please Enter OTP");
      return;
    }
    if (otp.length !== OTP_LENGTH) {
      setOtpError(`Please enter a valid ${OTP_LENGTH}-digit OTP`);
      return;
    }
    if (timer <= 0) {
      setOtpError("OTP expired. Please click on Resend OTP");
      return;
    }
    setOtpError("");
    try {
      const response = await dispatch(LoginverifyOtp({ contact_no, otp }));
      if (response?.payload?.success) {
        const token = response?.payload?.data?.token;
        if (token) {
          Cookies.set("excellent_website_security", token, {
            expires: 7,
            path: "/",
            sameSite: "Lax",
            secure: window.location.protocol === "https:",
          });
        }
        try {
          await dispatch(Getprofile()).unwrap();
        } catch (e) {
          console.error("Failed to fetch profile:", e);
        }
        try {
          await dispatch(GetAllUserTest()).unwrap();
        } catch (e) {
          console.error("Failed to fetch user tests:", e);
        }
        // Show "Login Successfully" popup, then close login modal
        setLoginSuccessData(response?.payload?.data ?? null);
        setLoginSuccessShow(true);
        if (loginSuccessTimeoutRef.current) clearTimeout(loginSuccessTimeoutRef.current);
        loginSuccessTimeoutRef.current = setTimeout(() => {
          setLoginSuccessShow(false);
          handleClose?.();
          handleLogin?.(response?.payload?.data);
        }, 1500);
      } else {
        // Safety net: if OTP was empty, never show backend "Invalid OTP"
        if (!otp) {
          setOtpError("Please Enter OTP");
        } else {
          setOtpError(
            response?.payload?.message || response?.error?.message || "Invalid OTP. Please try again."
          );
        }
      }
    } catch (error) {
      console.error("Failed to verify OTP:", error);
      if (!otp) {
        setOtpError("Please Enter OTP");
      } else {
        setOtpError("Invalid OTP. Please try again.");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSending || isVerifying) return;
    if (!showOtpStep) handleSendOtp(false);
    else handleVerifyOtp();
  };

  const handleOtpChange = (value) => {
    const numericValue = value.replace(/[^0-9]/g, "").slice(0, OTP_LENGTH);
    setOtp(numericValue);
    if (otpError) setOtpError("");
  };

  const handleModalClose = () => {
    if (isSending || isVerifying || loginSuccessShow) return;
    handleClose?.();
  };

  const handleLoginSuccessClose = () => {
    if (loginSuccessTimeoutRef.current) clearTimeout(loginSuccessTimeoutRef.current);
    setLoginSuccessShow(false);
    handleClose?.();
    handleLogin?.(loginSuccessData);
  };

  const isPhoneValid = /^\d{10}$/.test(contact_no);

  return (
    <>
      <Modal
        className="login_modal"
        size="md"
        show={show}
        onHide={handleModalClose}
        centered
        backdrop={isSending || isVerifying ? "static" : true}
        keyboard={!(isSending || isVerifying)}
      >
        <Modal.Body className="counselling_modal">
          <div className="modal_header">
            <h5 className="modal_title">Login to Continue Your Career Journey</h5>
            <div className="close_div">
              <button
                type="button"
                className="close_btn_wrap"
                onClick={handleModalClose}
                aria-label="Close login dialog"
                disabled={isSending || isVerifying}
              >
                <img
                  src="/assets/images/home_banner/close.png"
                  alt="close"
                  className="close_btn"
                />
              </button>
            </div>
          </div>

          <Form onSubmit={handleSubmit} noValidate>
            <Row>
              <Col md={12} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="login-phone">Phone Number</Form.Label>
                  <div className="phone_row">
                    <Form.Control
                      id="login-phone"
                      type="tel"
                      autoComplete="tel"
                      inputMode="numeric"
                      value={contact_no}
                      onChange={handlePhoneChange}
                      onBlur={handlePhoneBlur}
                      maxLength={10}
                      disabled={isPhoneLocked || isSending || isVerifying}
                      isInvalid={!!phoneError}
                      placeholder="Enter Your Phone Number"
                    />
                    {isPhoneLocked && (
                      <button
                        type="button"
                        className="change_number_btn"
                        onClick={handleChangeNumber}
                        disabled={isSending || isVerifying}
                      >
                        Change
                      </button>
                    )}
                  </div>
                  {phoneError ? (
                    <p
                      className="text-danger mt-1 mb-0"
                      style={{ display: "block", fontSize: "13px" }}
                    >
                      {phoneError}
                    </p>
                  ) : null}
                </Form.Group>
              </Col>

              {showOtpStep && (
                <Col md={12} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>OTP</Form.Label>
                    <div className="otp_wrapper">
                      <OtpInput
                        value={otp}
                        onChange={handleOtpChange}
                        numInputs={OTP_LENGTH}
                        shouldAutoFocus
                        renderInput={(props) => (
                          <input
                            {...props}
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            pattern="[0-9]*"
                            disabled={isVerifying}
                            className="otp_input_box"
                            onKeyDown={(e) => {
                              if (/^[0-9]$/.test(e.key)) return;
                              if (
                                [
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Tab",
                                ].includes(e.key)
                              ) {
                                return;
                              }
                              e.preventDefault();
                            }}
                          />
                        )}
                      />
                    </div>
                    {otpError && <p className="text-danger mt-2 mb-0">{otpError}</p>}
                    {timer > 0 ? (
                      <p className="otp-timer mt-2 mb-0">OTP valid for {timer}s</p>
                    ) : (
                      <p className="otp-expired mt-2 mb-0">
                        OTP expired.{" "}
                        <button
                          type="button"
                          className="resend_link"
                          onClick={() => handleSendOtp(true)}
                          disabled={isSending}
                        >
                          {isSending ? "Sending..." : "Resend OTP"}
                        </button>
                      </p>
                    )}
                  </Form.Group>
                </Col>
              )}
            </Row>

            <div className="btns_holder">
              {!showOtpStep ? (
                <>
                  <Start_Btn
                    type="submit"
                    text={isSending ? "Sending..." : "Get OTP"}
                    disabled={isSending}
                  />
                  {isSending && (
                    <div className="mt-2">
                      <Spinner animation="border" role="status" size="sm">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  )}
                </>
              ) : (
                <div className="login_actions">
                  {isVerifying ? (
                    <Spinner animation="border" role="status" size="sm">
                      <span className="visually-hidden">Verifying...</span>
                    </Spinner>
                  ) : (
                    <Start_Btn
                      type="submit"
                      text="Login"
                      disabled={isVerifying}
                    />
                  )}
                  {timer === 0 && !isVerifying && (
                    <Start_Btn
                      text={isSending ? "Sending..." : "Resend OTP"}
                      onClick={() => handleSendOtp(true)}
                      disabled={isSending}
                    />
                  )}
                </div>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={successShow}
        handleClose={() => setSuccessShow(false)}
        message="OTP Sent Successfully"
      />
      <Success_Modal
        show={loginSuccessShow}
        handleClose={handleLoginSuccessClose}
        message="Login Successfully"
      />
    </>
  );
};

export default Login_Modal;

